module.exports = __webpack_public_path__ + "static/media/Brightly_ios_2_preview.7f4e5625.jpg";